import React, { FC, useEffect, useState } from 'react';
import CompanyVO from '@domain/vo/search/CompanyVO';
import { V2Route } from '@utils/routeUtil';

import NumberFormat from '@utils/number/format';
import classnames from 'classnames/bind';
import styles from './companyList.module.scss';
const cx = classnames.bind(styles);

interface ICompanyCardProps {
  vo: CompanyVO;
}

const CompanyCard: FC<ICompanyCardProps> = ({ vo }) => {
  const { sn, name, logoImageUrl, locationName, vision, numberOfPositions } = vo;
  const url = V2Route.getCompanyChannelPage(sn);
  const positionCountText = NumberFormat.formatPositionCountInCompany(numberOfPositions);

  return (
    <li className={cx('listItem')}>
      <a className={cx('link')} href={url} rel="noreferrer">
        <span
          className={cx('logo', { default: !logoImageUrl })}
          style={{ backgroundImage: logoImageUrl && `url(${logoImageUrl})` }}
        />
        <span className={cx('companyInfoArea')}>
          <span className={cx('companyInfoInner')}>
            <span className={cx('companyName')}>{name}</span>
            {locationName && <span className={cx('companyLocation')}>{locationName}</span>}
          </span>
          <span className={cx('companyInfoInner')}>
            <span className={cx('companyDesc')}>{vision}</span>
          </span>
        </span>

        <span className={cx('postText', { on: numberOfPositions > 0 })}>
          {positionCountText}개 포지션
          <br />
          채용중
        </span>
      </a>
    </li>
  );
};

interface ICompanyListProps {
  companyList: CompanyVO[];
}

const CompanyList: FC<ICompanyListProps> = ({ companyList }) => {
  const [moreBtnVisible, setMoreBtnVisible] = useState(false);
  const totalCount = companyList.length;
  const viewCompanyList = moreBtnVisible ? companyList.slice(0, 6) : companyList;

  const onClickMoreBtn = () => {
    setMoreBtnVisible(false);
  };

  const companyListEl = viewCompanyList.map((item) => {
    return <CompanyCard vo={item} key={item.sn} />;
  });

  useEffect(() => {
    if (companyList.length > 6) {
      setMoreBtnVisible(true);
    }
  }, [companyList]);

  return (
    <>
      <ul className={cx('companyList')}>{companyListEl}</ul>
      {moreBtnVisible && (
        <div className={cx('btnMoreArea')}>
          <a className={cx('btnMore')} role="button" onClick={onClickMoreBtn}>
            {totalCount}개 기업 검색 결과 모두보기
          </a>
        </div>
      )}
    </>
  );
};

export default CompanyList;
